import { createContext } from 'react';

const SelectionContext = createContext(undefined);

export default SelectionContext;
